import script from "./CustomFieldNameCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldNameCell.vue?vue&type=script&setup=true&lang=js"

import "./CustomFieldNameCell.vue?vue&type=style&index=0&id=6c286a70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c286a70"]])

export default __exports__